import React from 'react'
import injectSheet from 'react-jss'
import styles from './discussion.styles'
import ContributionForm from '../../../../../shared/contribution-form/contribution-form.container'
import DiscussionFeed from '../../../../../shared/discussion-feed/discussion-feed.container'
import classNames from 'classnames'
import Spinner from 'pobble-components/dist/spinner'

const Discussion = ({
  classes,
  open,
  pending,
  conclusionAuthor,
  conclusionContent
}) => {
  return (
    <aside
      className={classNames(classes.container, {
        [classes.open]: open
      })}>
      <div className={classes.inner}>
        <div className={classes.discussion}>
          {conclusionContent && (
            <p className={classes.conclusion}>
              <strong>Conclusion:</strong> <em>{conclusionContent}</em> – 
              {conclusionAuthor}
            </p>
          )}
          <h3 className={classes.title}>Join the discussion</h3>
        </div>
        <ContributionForm />
        <div className={classes.discussion}>
          <DiscussionFeed />
          {pending && <Spinner className={classes.spinner} />}
        </div>
      </div>
    </aside>
  )
}

export default injectSheet(styles)(Discussion)
